export const READ_THREAD = 'READ_THREAD';